import { Reducer } from 'redux';
import { MachinePart } from "models/MachinePart";
import { IMachinePartActions, MachinePartActionType } from "redux/actions/settings/MachinePartActions";

const initialState: MachinePart[] | null = null;
export const machinePartsReducer: Reducer<MachinePart[] | null, IMachinePartActions> =
    (state = initialState, action) => {
        switch (action.type) {
            case MachinePartActionType.FETCH_MACHINEPARTS_SUCCESS:
                {
                    return action.returnPayload as MachinePart[];
                }
            case MachinePartActionType.ADD_MACHINEPART_SUCCESS:
                {
                    let newMachineParts = [...state!];
                    newMachineParts.push({ ...action.returnPayload } as MachinePart)
                    return newMachineParts;
                }
            case MachinePartActionType.EDIT_MACHINEPART_SUCCESS:
            case MachinePartActionType.DELETE_MACHINEPART_SUCCESS:
                {
                    let newParts = [...state!];
                    const updatedMachinePart = { ...action.returnPayload } as MachinePart;
                    newParts = newParts.map(nm => nm.id === updatedMachinePart.id ? updatedMachinePart : nm);
                    return newParts;
                }
            default:
                return state;
        }
    };
